export const ContractAddresses = {
  Minting: "0xa3abd1BCc4ad1F244F1E959f2b89A372C0727e69",
};
